export default {
  language: "English",
  nav: {
    home: "HOME",
    dealer: "AFFILIATE",
    help: "HELP & SUPPORT",
    subscription: "SUBSCRIPTION",
    couponCenter: "COUPON HALL"
  },
  userMenu: {
    login: "Login",
    profile: "Profile",
    subscription: "Subscribe",
    promotion: "My promotion",
    help: "Help & Support",
    order: "Orders",
    wallet: "My Wallet",
    coupons: "My Coupons",
    changeLang: "Languages",
    logout: "Logout"
  },
  footer: {
    aboutUsTitle: "About Us",
    aboutUs: "About Us",
    contactUs: "Contact Us",
    business: "Business Cooperation",
    legalTitle: "Legal",
    terms: "Terms & Conditions",
    privacy: "Privacy Policy",
    refund: "Refund Policy",
    regionTitle: "Region",
    regionChina: "China",
    language: "Language",
    langZhCN: "Simplified Chinese",
    langEn: "English",
    serviceTitle: "Customer Service",
    helpSupport: "Help & Support",
    onlineService: "Online Service"
  },
  header: {
    helpTitle: "How can we help?",
    searchPlaceholder: "Enter keywords to search",
    recommendTitle: "Recommended for you",
    changeAnother: "Change",
    subscriptionTitle: "Subscription Services",
    userCenterTitle: "Profile",
    myAccountTitle: "My Account",
    myPromotionTitle: "My Promotion",
    myWalletTitle: "My Wallet",
    myCouponsTitle: "My Coupons",
    orderTitle: "Order History",
    couponCenterTitle: "Coupon Hall",
    registerCouponTitle: "New User Coupon",
    '立即與OTTBUS合作吧！':'Cooperate with OTTBUS right away !',
    '加入我們，開啓賺錢的旅程！':'Join us and start your journey to make money !',
    '馬上開始':'Start Earning Now',
  },
  login: {
    welcomeTitle: "Hello!",
    welcomeSubtitle: "Enjoy a wonderful experience!",
    cardTitle: "Sign in or Sign up",
    emailPlaceholder: "Email",
    passwordPlaceholder: "Password",
    useCodeLogin: "Use verification code login",
    codePlaceholder: "Verification Code",
    sending: "Sending...",
    sendCode: "Send Code",
    sent: "Sent",
    passwordLogin: "Password Login",
    instruction: "Please use the email you used to register OTTBUS to log in",
    continue: "Continue",
    or: "or",
    termsPrefix: "By continuing, you agree to our ",
    termsLinkText: "Terms & Conditions",
    privacyPrefix: " and confirm that you have read our ",
    privacyLinkText: "Privacy Policy",
    discountRate: " Up to 80% Off",
    discountDesc: "Half the subscription cost, double the joy!"
  },
  auth: {
    confirmLogout: "Are you sure you want to log out?",
    confirmTitle: "Confirm",
    ok: "OK",
    cancel: "Cancel",
    invalidEmail: "Please enter a valid email address",
    passwordRequired: "Password cannot be empty",
    loginSuccess: "Login successful",
    codeRequired: "Please enter the verification code",
    passwordLength: "Password length must be between 6 and 20 characters",
    passwordMismatch: "The two passwords do not match",
    registerLoginSuccess: "Registered and logged in successfully",
    unsupportedPasswordLogin: "This account does not support password login. Please use code login.",
    loginFailedUseCode: "Login failed, please use code login",
    loginFailedRetry: "Login failed, please try again",
    codeSendFailed: "Failed to send verification code, please try again later"
  },
  setPassword: {
    title: "Set Password",
    description: "To enhance account security and avoid login issues when a verification code cannot be received, please set a login password.",
    passwordPlaceholder: "Enter password",
    confirmPasswordPlaceholder: "Confirm password",
    requirementsTitle: "Your password must include:",
    requirementLength: "8 to 20 characters",
    requirementFormat: "Letters and numbers",
    requirementMatch: "Both passwords match",
    continue: "Continue",
    skip: "Skip",
    success: "Password set successfully",
    failure: "Failed to set password, please try again"
  },
  helpPage: {
    feedbackCardTitle: "Submit Feedback",
    feedbackCardSubtitle: "Tell us the issue you encountered",
    serviceCardTitle: "Online Support",
    serviceCardSubtitle: "24/7 one-stop service",
    dialogTitle: "Feedback",
    formProblemTitle: "Feedback",
    formProblemPlaceholder: "Please describe your issue",
    formContactTitle: "Contact Information",
    formContactPlaceholder: "Please enter your contact info",
    submit: "Submit",
    problemRequired: "Description cannot be empty",
    contactRequired: "Contact information cannot be empty",
    confirmSubmit: "Are you sure to submit the feedback?",
    confirmTitle: "Confirm",
    ok: "OK",
    cancel: "Cancel",
    submitSuccess: "Submitted successfully!",
    '聯繫專屬客服以獲取高效支持': 'Contact our dedicated customer service for efficient support',
    // Help center multi-language
    helpCenter: "Help Center",
    searchPlaceholder: "Search help center...",
    hotArticles: "Popular Questions",
    frequentlyReadArticles: "Frequently Read Articles",
    browseAllCategories: "Browse All Categories",
    categories: "Categories",
    searchResults: "Search Results",
    clearSearch: "Clear Search",
    noResults: "No results found",
    noArticles: "No articles yet",
    loading: "Loading...",
    loadMore: "Load More",
    back: "Back",
    goToWebsite: "Go to website",
    howCanWeHelp: "How can we help you?",
    articlesOn: "Articles on",
    viewCount: "Few readers",
    defaultCategoryDesc: "View related help articles"
  },
  helpDetail: {
    title: "Help Center",
    updated: " updated",
    relatedArticles: "Related articles"
  },
  userProfile: {
    title: "Profile",
    nickname: "Nickname",
    email: "Email",
    password: "Password",
    editNickname: "Edit Nickname",
    nicknamePlaceholder: "Enter nickname",
    submit: "Submit",
    editPassword: "Edit Password",
    codeSent: "Verification code has been sent to {email}, please check:",
    codePlaceholder: "Enter verification code",
    sendCode: "Send Code",
    resendIn: "Resend in {time}S",
    newPasswordPlaceholder: "Set a password",
    confirmPasswordPlaceholder: "Confirm password",
    editEmail: "Edit Email",
    newEmailPlaceholder: "Enter new email",
    updateSuccess: "Updated successfully",
    passwordRequired: "Password cannot be empty",
    passwordMismatch: "The two passwords do not match",
    nicknameRequired: "Please enter a nickname!",
    uploadFailed: "File upload failed, please try again",
    uploading: "Uploading image, please wait..."
  },
  subscriptionPage: {
    title: "Subscription Services",
    tagRecharging: "Recharging",
    tagToRedeem: "To Redeem",
    tagSubscribed: "Subscribed",
    productLabel: "Product:",
    codeLabel: "Redeem Code:",
    startTime: "Start Time:",
    endTime: "End Time:",
    remark: "Remark:",
    renewService: "Renew Service",
    goRedeem: "Go to Redeem",
    newTicket: "New Ticket",
    faq: "FAQ",
    emptyText: "No subscription content yet",
    goSubscribe: "Go Subscribe",
    dialogNewTicketTitle: "New Ticket",
    emailLabel: "Email",
    emailPlaceholder: "Please enter your email",
    questionTypeLabel: "Question Type",
    selectPlaceholder: "Please select",
    questionDetailLabel: "Question Detail",
    submit: "Submit",
    redeemSuccessTitle: "Redeemed Successfully",
    accountLabel: "Account:",
    passwordLabel: "Password:",
    rechargeAccount: "Recharge Account:",
    copySuccess: "Redeem code copied!",
    copyFail: "Copy failed",
    confirmRedeem: "Confirm to redeem?",
    emailRequired: "Please enter your email!",
    questionTypeRequired: "Please select a question type!",
    detailRequired: "Please fill in the question detail!",
    submitSuccess: "Submitted successfully!",
    '订单编号': 'Order Number',
    '联系客服': 'Contact Us',
    expand: 'Expand',
    collapse: 'Collapse',
    adminRemark: 'Remark',
    captchaLabel: 'Captcha',
    fetching: 'Fetching...',
    clickToGet: 'Get Verification Code',
    viewDetail: 'View Verification Details',
    noCaptchaEmail: 'Unable to get verification code. Please resend or wait 1 minute before trying again'
  },
  orderPage: {
    title: "Order Records",
    all: "All",
    unpaid: "Unpaid",
    paid: "Paid",
    completed: "Completed",
    refunded: "Refunded",
    thName: "Order Name",
    thDuration: "Subscription Time",
    thAmount: "Amount Paid",
    thStart: "Effective Time",
    thStatus: "Order Status",
    idPrefix: "ID:",
    emptyText: "No content yet",
    status: {
      0: "Unpaid",
      1: "Paid",
      2: "Completed",
      9: "Refunded",
      "-1": "Canceled"
    },
    duration: {
      1: "1 Month",
      3: "3 Months",
      6: "6 Months",
      12: "12 Months"
    },
    '订单编号': 'Order Number',
    '操作': 'Operation',
    '退款': 'Refund',
    '去支付': 'Pay Now',
    cancelOrder: 'Cancel Order',
    cancelOrderConfirm: 'Are you sure you want to cancel this order?',
    cancelOrderSuccess: 'Order canceled',
    cancelOrderFailed: 'Cancel failed, please try again later',
    cancelOrderForbiddenPaid: 'This order already has a successful payment record and cannot be canceled',
    '退款申请': 'Refund Request',
    '退款理由': 'Refund reason',
    '请填写退款理由': 'Please fill in the reason for refund',
    '订单不存在': 'Order does not exist',
    '订单不支持退款': 'Order does not support refunds',
    '申请失败': 'Application failed',
    '操作成功': 'Operation successful',
    refundStatus: {
      1: 'Refund application in progress',
      2: 'Pending confirmation',
      3: 'Rejected by admin',
      4: 'Refund successful',
      5: 'Rejected by customer'
    },
    // Refund confirmation related
    confirmRefund: 'Confirm Refund',
    refundConfirmTitle: 'Refund Confirmation',
    refundAmountLabel: 'Refund Amount',
    refundConfirmTip: 'After confirming the refund, the amount will be returned to your wallet',
    agreeRefund: 'Agree to Refund',
    rejectRefund: 'Reject Refund',
    refundSuccess: 'Refund successful, amount returned to wallet',
    refundRejected: 'Refund rejected',
    operationFailed: 'Operation failed',
    refundDisabledTip: 'Refund function is not enabled, please contact customer service',
    checkRefundFailed: 'Failed to check refund permission',
    refundContactService: 'Please contact customer service for refund',
    adminRemark: 'Remark',
    refundApplySuccess: 'Refund application submitted',
    refundRemarkLabel: 'Review Result'
  }
  ,
  indexPage: {
    titlePart1: "What We",
    titlePart2: " Offer",
    menuRecommend: "All",
    sharingUsersSuffix: " users are sharing",
    buyNow: "Go to Buy",
    more: "more",
    foldUp: "less",
    noContent: "No content yet",
    advantagesTitlePart1: "What are our",
    advantagesTitlePart2: " advantages?",
    consultNow: "Consult Now",
    feedbackTitle: "Excellent user feedback",
    bulletCheap: "Affordable price, family plan is more cost-effective",
    bulletDesktopOnly: "Desktop only: Windows and macOS",
    coupon: {
      headerTitle: "Newcomer Exclusive Benefits",
      headerSubtitle: "Welcome aboard, here is a gift for you",
      discountConditionPrefix: "Valid on orders over ",
      discountConditionSuffix: " available",
      directDiscount: "No minimum, direct discount",
      validityLabel: "Valid until",
      cardNote: "Available on your first order",
      rule1: "New users can claim immediately",
      rule2: "Applicable site-wide, except special items",
      rule3: "Valid within 12 months after claiming",
      receiveBtn: "Claim Now",
      successTitle: "Claimed successfully!",
      successMessage: "Coupon has been added to your account, go use it!",
      successOk: "OK"
    },
    dialog: {
      buyTitle: "Purchase Product",
      type: "Type",
      direct: "Recharge",
      shared: "Shared",
      duration: "Duration",
      couponCode: "Do you have a discount code?",
      couponPlaceholder: "Please enter discount code",
      note: "Kind reminder: Due to the nature of virtual products, refunds are not supported after 24 hours of sale. If there is any product issue, we will fix it as soon as possible and compensate your usage time to ensure a good experience.",
      submit: "Submit",
      accountTitle: "Account & Password",
      accountLabel: "Recharge Account",
      passwordLabel: "Password",
      backupCodeLabel: "Backup Code",
      payTitle: "Select Payment Method",
      payMethod: "We will not store your bank card information. All transactions are protected, processed, and authorized by external payment providers. (If payment redirection fails, please replace the device and try again)",
      confirm: "Confirm",
      save: "save",
      orgPrice: "Price：",
      '请填写充值账号': 'Please fill in the recharge account',
      '请填写充值账号密码': 'Please fill in the recharge account password',
      '请填写充值账号备用码': 'Please fill in the backup code for the recharge account',
      '节约': 'save',
      '注意事项': 'Note',
      googleBakCode: 'How to set up Google  Backup verification code',
      noStock: 'Out Of Stock',
      '备注': 'Note',
      '请填写充值账号备注': 'Please enter the name of the UP blogger and the corresponding membership category.',
      '数量': 'Quantity',
      '请输入您要充值的账户(GoogleMail)': 'Please enter the account you wish to recharge.(Google Mail)',
      '购买须知': 'Purchase Instructions'
    },
    validate: {
      fillAccount: "Please enter the recharge account",
      fillPassword: "Please enter the account password",
      choosePayMethod: "Please select a payment method"
    },
    adv: {
      payNowTitle: "Immediate delivery",
      payNowDesc: "Instant delivery after payment - no waiting required",
      customerServiceTitle: "Customer Service",
      customerServiceDesc: "OTTBUS provides 7x24 hour online customer service",
      globalPayTitle: "Global payments",
      globalPayDesc: "Ensuring payment security from over 100 countries",
      shareTitle: "Subscribe to Share",
      shareDesc: "Affordable premium subscription sharing: prioritize matching by location",
      refundTitle: "Quick Refund",
      refundDesc: "24-hour unconditional refund",
      premiumTitle: "Advanced Center",
      premiumDesc: "Experience a \"one-stop\" premium subscription on OTTBUS"
    },
    type: {
      '视频': 'Video',
      '音乐': 'Music',
      'AI': 'AI',
      '办公': 'Office',
      '学习': 'Learn',
      '其他': 'Other'
    },
    month: " Month",
    months: " months",
    permanent: "Lifetime",
    pay: {
      creditcardKR: "South Korea Credit Card",
      ebankingKR: "South Korea Internet Banking",
      kakaopay: "KakaoPay",
      payco: "PAYCO",
      ssgpay: "SSG Pay",
      samsungpay: "Samsung Pay",
      alipayHK: "Mainland Alipay",
      alipayWalletHK: "AlipayHK",
      alipayTW: "Mainland Alipay",
      jkoTW: "JKOPay",
      useWallet: "Use Wallet Balance",
      walletBalance: "Wallet Balance",
      walletDeduct: "Wallet Deduction",
      walletDeductInput: "Wallet Deduction Amount",
      walletDeductMaxTip: "Maximum deductible",
      remainingToPay: "Remaining to Pay",
      enterPayPassword: "Enter 6-digit payment password",
      noPasswordTip: "Payment password not set",
      goSetPassword: "Set Now",
      paySuccess: "Payment Successful",
      payFailed: "Payment failed, please try again",
      paymentUrlError: "Failed to get payment link, please try again",
      insufficientBalance: "Insufficient wallet balance",
      walletAlreadyPaid: "Wallet payment applied",
      walletAlreadyUsed: "This order has already used wallet payment",
      walletPendingTip: "Wallet deduction is staged and will be charged only after payment succeeds",
      regionAutoDetectFallback: "We could not identify your region. Payment methods for Korea, Hong Kong, and Taiwan are shown below. Please choose one manually.",
      antomCashierTitle: "Opening Payment Page",
      antomCashierDescription: "The system will render the matching payment component on this page. If it does not appear correctly, use the button below to try again.",
      antomCashierLoading: "Loading payment component...",
      antomCashierReady: "The payment component is ready. Please complete the payment below.",
      antomCashierOpenFailed: "Failed to open the payment page. Please try again.",
      antomCashierMissingSession: "The payment session has expired. Please go back and create the order again.",
      antomCashierRetry: "Open Payment Again",
      antomCashierBackHome: "Back to Home",
      antomCashierOrderCode: "Order Code",
      antomCashierAmount: "Payment Amount",
      antomCashierSuccessHint: "Payment has been submitted. Please wait for the order status to update.",
      antomCashierCancelHint: "The payment was cancelled. You can start it again.",
      antomCashierEventPrefix: "Payment component status",
      antomResultTitle: "Confirming Payment Result",
      antomResultDescription: "After the payment is completed, this page will query the latest order status.",
      antomResultLoading: "Checking the latest order status...",
      antomResultPending: "The payment result is still syncing. Please wait a moment.",
      antomResultPaid: "The order has been paid.",
      antomResultCompleted: "The order is completed.",
      antomResultRefunded: "The order has been refunded.",
      antomResultUnknown: "The final status is not available yet. Please check again later in the order center.",
      antomResultMissingOrder: "Missing payment order code. The result cannot be queried.",
      antomResultNoLogin: "You are not logged in, so the order status cannot be checked automatically. Please sign in and open the order center.",
      antomResultQueryFailed: "Failed to query the order status. Please try again later.",
      antomResultOrderStatus: "Order Status",
      antomResultRetry: "Check Again",
      antomResultViewOrders: "View Orders"
    }
  }
  ,
  promotionPage: {
    myPromotion: "My Promotion",
    myWallet: "My Wallet",
    code: "Promotion Link：",
    promotionRecords: "Promotion Records",
    totalCommission: "Total Commission: ",
    thOrderName: "Order Name",
    thDuration: "Subscription Time",
    thPaid: "Amount Paid",
    thEffective: "Effective Time",
    thBuyer: "Buyer",
    thCommission: "Commission",
    thStatus: "Status",
    settled: "Settled",
    pending: "Pending",
    unpaid: "Unpaid",
    refunded: "Refunded",
    goodsDetail: "Products",
    thPrice: "Price",
    commissionRate: "Commission Rate",
    commissionAmount: "Commission Amount",
    remark: "Remark",
    withdrawable: "Withdrawable:",
    withdraw: "Withdraw",
    withdrawalRecords: "Withdrawal Records",
    totalWithdrawal: "Total Withdrawal: ",
    thWithdrawAmount: "Amount",
    thBank: "Bank Card",
    thCardholder: "Cardholder",
    thWithdrawTime: "Time",
    thWithdrawStatus: "Status",
    withdrawAmount: "Withdrawal Amount",
    bankCard: "Bank Card Number",
    cardholder: "Cardholder Name",
    placeholderWithdrawAmount: "Enter withdrawal amount",
    placeholderBankCard: "Enter bank card number",
    placeholderCardholder: "Enter cardholder name",
    '链接复制成功': 'Link copied success',
    adAgentNoWithdraw: "Ad agents cannot withdraw",
    adAgentNotice: "You are an ad agent user and cannot withdraw. Commissions will not be credited. Please contact customer service if you have any questions.",
    // Bank card management
    myBankCards: "My Bank Cards",
    addBankCard: "Add Bank Card",
    editBankCard: "Edit Bank Card",
    noBankCards: "No bank cards yet. Please add one first",
    selectBankCard: "Select Bank Card",
    manualInput: "Manual Input",
    bankName: "Bank Name",
    cardNumber: "Card Number",
    cardHolder: "Cardholder Name",
    placeholderBankName: "Enter bank name",
    placeholderCardNumber: "Enter card number",
    placeholderCardHolder: "Enter cardholder name",
    setAsDefault: "Set as default card",
    defaultCard: "Default",
    save: "Save",
    saveSuccess: "Saved successfully",
    saveFailed: "Save failed",
    deleteSuccess: "Deleted successfully",
    confirmDeleteCard: "Are you sure you want to delete this bank card?",
    confirmWithdraw: "Are you sure you want to withdraw?",
    withdrawSuccess: "Withdrawal request submitted",
    withdrawAmountExceeded: "Withdrawal amount cannot exceed available balance",
    // Withdraw method
    myWithdrawAccounts: "My Withdraw Accounts",
    addWithdrawAccount: "Add Withdraw Method",
    editWithdrawAccount: "Edit Withdraw Method",
    noWithdrawAccounts: "No withdraw accounts yet. Please add one first",
    withdrawType: "Withdraw Method",
    selectWithdrawType: "Select withdraw method",
    usdtAddress: "USDT Wallet Address (TRC20)",
    placeholderUsdtAddress: "Enter USDT wallet address"
  }
  ,
  hello: {
    guideLine1: "For a guide and recipes on how to configure / customize this project,",
    guideCheckOut: "check out the",
    vueCliDocs: "vue-cli documentation",
    installedTitle: "Installed CLI Plugins",
    plugins: { babel: "babel", eslint: "eslint" },
    essentialTitle: "Essential Links",
    links: {
      coreDocs: "Core Docs",
      forum: "Forum",
      communityChat: "Community Chat",
      twitter: "Twitter",
      news: "News"
    },
    ecosystemTitle: "Ecosystem",
    ecosystem: {
      router: "vue-router",
      vuex: "vuex",
      devtools: "vue-devtools",
      loader: "vue-loader",
      awesome: "awesome-vue"
    }
  }
  ,
  dealerPage: {
    adv1Title: "Professional Team",
    adv1Desc: "Professional service, join OTTBUS",
    adv2Title: "Share to Earn",
    adv2Desc: "Earn commission by sharing links",
    adv3Title: "Renewal Commission",
    adv3Desc: "Earn extra when users renew",
    adv4Title: "24/7 Service",
    adv4Desc: "One-on-one professional support",
    advantagesTitle: "Why choose us?",
    advantagesSubtitle: "Earn commission with ease",
    startNow: "Start Now",
    howToJoinTitle: "How to join us?",
    howToJoinSubtitle: "Earn commission with ease",
    join1Title: "Register Account",
    join1Desc: "Register first, then go to the dealer section",
    join2Title: "Apply to Join",
    join2Desc: "Apply in the dealer section; after approval you can invite",
    join3Title: "Share Invites",
    join3Desc: "Share invite link; purchases via link earn commission",
    shareSlogan: "Join us and start earning with your link!",
    startEarning: "Start Earning Now",
    dialogTitle: "Join Us",
    detailSubtitle: "OTTBUS looks forward to your joining. Please fill in the form to make it easier to join.",
    formRealName: "Full Name",
    placeholderRealName: "Please enter your name",
    formPhone: "Phone Number",
    placeholderPhone: "Please enter phone number",
    formCurrency: "Account Currency",
    formPromotionWhere: "Where will you promote OTTBUS?",
    placeholderLink: "Please enter link",
    formLanguageQuestion: "Which language will you use for social media promotion?",
    selectPlaceholder: "Please select",
    formContactHow: "How can we contact you?",
    placeholderContactInfo: "Your contact info",
    formPaymentWay: "Which payment method would you like to use?",
    formInviteCode: "Invitation code (optional)",
    placeholderInviteCode: "Please enter invite code",
    close: "Close",
    submit: "Submit",
    validate: {
      fillRealName: "Please enter your full name",
      fillPhone: "Please enter your phone number",
      chooseCurrency: "Please choose account currency",
      choosePromotionChannels: "Please choose at least one promotion channel",
      promotionLinkRequired: "Promotion channel link cannot be empty",
      chooseLanguage: "Please choose social language",
      chooseContactType: "Please choose contact type",
      fillContactInfo: "Please enter contact information",
      choosePaymentWay: "Please choose payment method"
    },
    confirmSubmit: "Are you sure to submit?",
    submitSuccess: "Submitted successfully!",
    '开启您的推广之旅': 'Embark on your promotional journey'
  },
  text: {
    '已经领取过': 'You have already received it',
    '商品库存不足': 'Insufficient stock',
    '优惠码无效': 'The discount code is invalid',
    '请填写备注': 'Please fill in the Note',
    couponNotFound: 'Promo code not found or expired',
    couponUsed: 'This promo code has been used',
    couponExpired: 'This promo code has expired',
    stockInsufficient: 'Maximum quantity reached'
  },
  wallet: {
    myWallet: "My Wallet",
    balance: "Wallet Balance",
    balanceTip: "For platform use only, non-withdrawable",
    setPassword: "Set Payment Password",
    changePassword: "Change Password",
    records: "Transaction History",
    all: "All",
    income: "Income",
    expense: "Expense",
    refundIncome: "Refund Credit",
    paymentExpense: "Payment",
    noRecords: "No transaction records",
    loading: "Loading...",
    loadMore: "Load More",
    oldPassword: "Current Password",
    newPassword: "New Password",
    password: "Payment Password",
    confirmPassword: "Confirm Password",
    enterOldPassword: "Enter current password",
    enterPassword: "Enter 6-digit password",
    enterConfirmPassword: "Re-enter password",
    passwordTip: "Payment password must be 6 digits",
    confirm: "Confirm",
    passwordLengthError: "Password must be 6 digits",
    passwordFormatError: "Password must be 6 digits",
    passwordNotMatch: "Passwords do not match",
    setSuccess: "Password set successfully",
    operationFailed: "Operation failed, please try again"
  },
  couponHall: {
    pageTitle: "Collect platform coupons",
    pageSubtitle: "Browse claimable offers, check quota and validity rules, and claim directly after login.",
    loginTip: "Guests can browse the hall first. Log in to claim available coupons to your account.",
    allGoods: "All goods",
    receiveNow: "Claim Now",
    loginToReceive: "Log In to Claim",
    viewMyCoupons: "View My Coupons",
    receiveSuccess: "Coupon claimed successfully",
    receiveFailed: "Failed to claim coupon",
    statusAvailable: "Available",
    statusUpcoming: "Upcoming",
    statusEnded: "Ended",
    statusSoldOut: "Sold Out",
    statusLimitReached: "Limit Reached",
    conditionLabel: "Condition",
    validityLabel: "Validity",
    windowLabel: "Claim Window",
    quotaLabel: "Quota",
    goodsLabel: "Goods",
    unlimited: "Unlimited",
    remaining: "Remaining",
    perUserLimit: "Per User Limit",
    emptyTitle: "No coupons are available right now",
    emptySubtitle: "The hall is temporarily empty or the activities are hidden. Please check again later or continue shopping.",
    goShopping: "Go Shopping"
  },
  coupon: {
    myCoupons: "My Coupons",
    couponTip: "View and manage your coupons",
    claimEntrance: "Claim New User Coupon",
    claimPageTitle: "New User Coupon",
    claimPageSubtitle: "Claim it once and use it directly during checkout",
    claimNow: "Claim Now",
    loginToClaim: "Log In to Claim",
    loginRequiredTip: "Guests can preview this coupon. Log in to claim and add it to your account.",
    notClaimedYet: "Not claimed yet",
    alreadyClaimed: "Claimed",
    previewMode: "Preview Only",
    claimSuccess: "Claim successful",
    claimFailed: "Claim failed, please try again later",
    viewMyCoupons: "View My Coupons",
    all: "All",
    unused: "Unused",
    used: "Used",
    expired: "Expired",
    conditionLabel: "Use condition",
    statusLabel: "Status",
    couponCodeLabel: "Coupon code",
    minSpend: "Min. spend",
    noThreshold: "No minimum spend",
    validForDays: "Valid for {days} days after claim",
    directDiscount: "Direct Discount",
    validUntil: "Valid until",
    available: "Available",
    canUse: "Available",
    noCoupons: "No coupons yet",
    noCouponsTip: "No coupons available. Shop now to get more discounts",
    goShopping: "Go Shopping"
  },
  promotion: {
    invitedUsers: "Invited Users",
    userCount: "Users Invited",
    totalOrders: "Total Orders",
    pendingCommission: "Pending Commission",
    settledCommission: "Settled Commission",
    viewOrders: "View Orders",
    hideOrders: "Hide Orders",
    noUsers: "No invited users yet",
    registerTime: "Registered",
    orderStatus: "Status",
    statusPending: "Pending",
    statusPaid: "Paid",
    statusCompleted: "Completed",
    statusRefunded: "Refunded",
    statusUnknown: "Unknown"
  },
  orderDetail: {
    relatedProducts: "Related Products",
    faq: "FAQ",
    viewMoreFaq: "View More Questions"
  },
  detailPage: {
    selectSku: "Select SKU",
    sold: "Sold",
    subtotal: "Subtotal",
    couponDiscount: "Promo Code & Coupon",
    selectCoupon: "Select a coupon",
    total: "Total",
    hasCoupon: "Have a promo code?",
    hasCouponAvailable: "You have available coupons",
    noCoupon: "No coupon",
    buyNow: "Buy Now",
    outOfStock: "Out of Stock",
    howToUse: "How to Use?",
    viewUsageGuide: "View Usage Guide",
    noUsageGuide: "No usage guide available",
    faq: "FAQ",
    relatedProducts: "Related Products",
    invalidCoupon: "Invalid coupon code",
    invalidCouponConfirmTitle: "Invalid Coupon",
    invalidCouponConfirmMessage: "The coupon you entered is invalid. Do you want to continue with the purchase?",
    continuePurchase: "Continue Purchase",
    selectDiscount: "Select Discount",
    pleaseSelect: "Please select",
    promoCodePlaceholder: "Enter promo code",
    apply: "Apply",
    quantity: "Quantity",
    unavailableTitle: "Product unavailable",
    unavailableMessage: "This product is currently unavailable to view or purchase in your region. Please return to the homepage and choose another item.",
    unavailableNoSpec: "This product does not have any sellable options at the moment. Please try again later.",
    backHome: "Back to home"
  }
}
